import { render, staticRenderFns } from "./InteractionsTotal.vue?vue&type=template&id=d082dfda&"
import script from "./InteractionsTotal.vue?vue&type=script&lang=js&"
export * from "./InteractionsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports